import { UserDto } from '@treetop/shared/model';

export enum CommentType {
  Comment = 0,
  ReaderFeedback = 1,
  PersonalNote = 2,
}

export type Comment = {
  id?: string;
  createdBy?: UserDto;
  createdAt?: Date;
  updatedAt?: Date;
  text: string;
  replies?: Comment[];
  parentId?: string;
  resolved?: boolean;
  type?: CommentType;
};

export type AnchoredComment = Comment & {
  anchor: CommentAnchor;
};

type BaseAnchor = {
  widgetId: string;
  path?: string;
};

export type TextAnchor = BaseAnchor & {
  type: 'text';
  elementId: string;
  start: number;
  length: number;
  selectedContent?: string;
};

export type ElementAnchor = BaseAnchor & {
  type: 'element';
  elementId: string;
};

export type FlowchartElementAnchor = BaseAnchor & {
  type: 'flowchart-element';
  elementId: string;
};

export type AnchoredTextComment = AnchoredComment & {
  anchor: TextAnchor;
};

export type AnchoredFlowchartComment = AnchoredComment & {
  anchor: FlowchartElementAnchor;
};

export type CommentAnchor = TextAnchor | ElementAnchor | FlowchartElementAnchor;

export type CommentsFilter = 'all' | 'resolved' | 'open';
